/* -----------------------------------------------------------------------
On Demand Webinar Template
-----------------------------------------------------------------------
Links (ctrl + click to follow):
Contentful Entries: https://app.contentful.com/spaces/n3ohnvkomoi9/entries?id=gQ9DJd1JJdYbFCKl&contentTypeId=individualWebinar&order.fieldId=updatedAt&order.direction=descending
Content Model: https://app.contentful.com/spaces/n3ohnvkomoi9/content_types/individualWebinar/fields
GraphQL Explorer: http://localhost:8000/___graphql?query=query%20MyQuery%20%7B%0A%20%20contentfulIndividualWebinar%0A%7D%0A
-----------------------------------------------------------------------
Supported components: Main Section
Slug: /on-demand-webinar/...
-------------------------------------------------------------------------*/

import React from 'react';
import { graphql } from 'gatsby';
import styled from 'styled-components';

import Video from '../components/basic/Video';
import Helmet from '../components/basic/Helmet';
import Layout from '../components/layout';
import StandaloneHubspotForm from '../components/cards/StandaloneHubspotForm';
import Text from '../components/basic/Text';
import Section from '../components/basic/layouts/Section';
import ThreeCardSection from '../components/sections/ThreeCardSection';

import theme from '../styles/theme';

const {
	colors,
	breakPoints: { screenQuery },
} = theme;

const Wrapper = styled(Section)`
	display: grid;
	grid-template-columns: 4fr 5fr;
	grid-column-gap: 60px;
	align-items: center;
	${screenQuery.medium} {
		grid-template-columns: 1fr;
		grid-row-gap: 40px;
	}
`;

const Page = ({ data, location, pageContext }) => {
	const content = data.contentfulPageTemplateWebinar;
	const relatedLinks = content.relatedCaseStudiesWebinarsOrBlogPosts;

	return (
		<Layout location={location}>
			<Helmet
				pageTitle={content.pageTitle + ' on demand'}
				description={content.description}
				location={location}
				featuredImage={
					content.featuredImage ? content.featuredImage.file.url : null
				}
				updatedAt={content.updatedAt}
				noIndex={pageContext.formType === 'Hubspot Form'}
			/>
			<Wrapper backgroundColor={colors.grayscale.light}>
				<div>
					<Text component="h1">{content.title}</Text>
					<Text component="b1">{content.description}</Text>
				</div>
				{content.webinarVideoLink ? (
					<Video
						url={content.webinarVideoLink ? content.webinarVideoLink : null}
						shadow
					/>
				) : null}
			</Wrapper>

			{relatedLinks?.length > 0 && <ThreeCardSection cards={relatedLinks} />}

			<StandaloneHubspotForm />
		</Layout>
	);
};

export default Page;

export const relatedWebinarQuery = graphql`
	query onDemandWebinarQuery($contentful_id: String!) {
		contentfulPageTemplateWebinar(contentful_id: { eq: $contentful_id }) {
			title
			pageTitle
			updatedAt
			description
			webinarVideoLink
			featuredImage {
				file {
					url
				}
			}
			relatedCaseStudiesWebinarsOrBlogPosts {
				... on ContentfulCard {
					...CardFragment
				}
				... on ContentfulPageTemplateWebinar {
					...WebinarCardFragment
				}
				... on ContentfulPageTemplateCustomerStory {
					...CustomerStoryCardFragment
				}
			}
		}
	}
`;
